import { FaEnvelope, FaInstagram, FaYoutube, FaFacebook, FaXTwitter } from "react-icons/fa6"; // using react-icons

function Header() {
  return (
    <div className="container mx-auto">
    <header className="container flex flex-col md:flex-row items-center justify-between gap-4 p-4 bg-white">
    {/* Left side - Logo */}
    <div>
      <a href="/">
      <img src="header_logo.svg" alt="Logo" className="h-20 w-80" />
      </a>
    </div>

    {/* Right side - Social Icons */}
    <div className="flex items-center space-x-6 text-gray-600 text-2xl">
      {/* space-x-6 gives bigger gap between icons */}
      
      <a href="#contact" className="hover:text-blue-500">
        <FaEnvelope />
      </a>
      <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="hover:text-pink-500">
        <FaInstagram />
      </a>
      <a href="https://www.youtube.com/@MemberMeld" target="_blank" rel="noopener noreferrer" className="hover:text-red-500">
        <FaYoutube />
      </a>
      {/* <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="hover:text-blue-700">
        <FaFacebook />
      </a> */}
      <a href="https://x.com" target="_blank" rel="noopener noreferrer" className="hover:text-black">
        <FaXTwitter />
      </a>
    </div>
  </header>
  </div>
  );
}

export default Header;